import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class CaisseService {
    Cash_Code;
    CashD_Id;    
}